module.exports = __webpack_public_path__ + "img/from-profile.78c89b62.svg";